import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommunicationsHttpService } from '../../../../services/communications/communications.http.service';
import { CommunicationsHttpUtil } from '../communications.util';
import { StorageUtil } from '../../../../utils/storage.util';
import { CommunicationsStateService } from '../communications.state.service';
import { AuthUtil } from '../../../../utils/auth.utils';

@Component({
  moduleId: module.id,
  templateUrl: 'search-communications.html',
  selector: 'bft-search-communications',
  providers: []
})

export class SearchCommunicationsComponent {

    @Output() inputText: EventEmitter<any> = new EventEmitter();

  constructor(
    private communicationsHttpService: CommunicationsHttpService,
    private communicationsStateService: CommunicationsStateService, private authUtil: AuthUtil
  ) { }

  inputSearchText({value}) {
    this.inputText.emit(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/communications/search-communications/search-communications.component.ts